/* eslint-disable react/prop-types */
import { Box, Stack, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { React, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import BillsIcon from '../assets/icons/BillsIcon'
import CostExplorerIcon from '../assets/icons/CostExplorerIcon'
import Styles from '../style/theme'

const ItemText = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 700,
  fontSize: '12px',
  lineHeight: '16px',
  letterSpacing: '0.08em',
  marginLeft: '8px',
})

function MenuItem(props) {
  const { name, path, icon } = props
  const location = useLocation()
  const navigate = useNavigate()
  const iaActive = location.pathname === path?.toLowerCase()
  const [isHover, setIsHover] = useState(false)

  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      sx={{
        backgroundColor: iaActive ? Styles.Color.PrimaryGray2 : Styles.Color.SecondaryGray1,
        borderBottom: `solid 0.5px ${Styles.Color.SecondaryGray2}`,
        boxShadow: iaActive ? `inset 4px 0px 0px ${Styles.Color.PrimaryDarkBlue}` : null,
        height: '72px',
        cursor: path ? 'pointer' : 'auto',
        '&:hover': {
          backgroundColor: Styles.Color.SecondaryGray1,
        },
      }}
      onClick={() => {
        if (path) navigate(path)
      }}
      onMouseOver={() => {
        setIsHover(true)
      }}
      onMouseOut={() => {
        setIsHover(false)
      }}>
      <Box
        sx={{
          marginLeft: '16px',
          width: '24px',
          height: '24px',
          color: iaActive || isHover ? Styles.Color.PrimaryDarkBlue : Styles.Color.SecondaryGray4,
        }}>
        {icon && icon === 'BillsIcon' ? <BillsIcon /> : null}
        {icon && icon === 'CostExplorerIcon' ? <CostExplorerIcon /> : null}
      </Box>
      <ItemText
        sx={{
          color: iaActive || isHover ? Styles.Color.PrimaryDarkBlue : Styles.Color.SecondaryGray4,
          width: '110px',
        }}>
        {name}
      </ItemText>
    </Stack>
  )
}

export default MenuItem
